import { Component, Input } from '@angular/core';
import { StackProps, stackStyles } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-stack',
  template: '<div [ngClass]="stackStyles"><ng-content></ng-content></div>',
})
export class StackComponent implements StackProps {
  /**
   * Css del componente
   */
  @Input() css: StackProps['css'];
  /**
   * Alineación de flexbox
   */
  @Input() align: StackProps['align'];
  /**
   * Dirección de flexbox
   */
  @Input() direction: StackProps['direction'];
  /**
   * Espaciado entre componentes
   */
  @Input() spacing: StackProps['spacing'];

  /**
   * Justify entre componentes
   */
  @Input() justify: StackProps['justify'];

  public get stackStyles(): string[] {
    return [
      stackStyles({
        css: this.css,
        align: this.align,
        direction: this.direction,
        spacing: this.spacing,
        justify: this.justify,
      }).className,
    ];
  }
}
